import React from 'react';
import Layout from "@/locales/en/layout/Layout";
import "../../../assets/schedule/schedule.css"
import "../../../assets/tezkunda/tezKunda.css"
import {useTranslation} from "react-i18next";

function Test(props) {
    const {t} = useTranslation();

    return (
        <Layout>
            <div className="schedule">
                <div className="container">
                    <p className="tezKunda">{t("examin")}</p>
                    <div className='bgimg'></div>
                </div>
            </div>

        </Layout>
    );
}

export default Test;